import _Number$MIN_SAFE_INTEGER from "@babel/runtime-corejs3/core-js/number/min-safe-integer";
import _Number$MAX_SAFE_INTEGER from "@babel/runtime-corejs3/core-js/number/max-safe-integer";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import { useCoreInput } from "@Shared/@Composables/inputs/useCoreInput";
import { defineComponent, toRefs } from "@vue/composition-api";
import { uniqueId } from "lodash";
import BaseLabel from "../base/base-label.vue";
import BaseInput from "../base/base-input.vue";
import BaseFieldLayout from "../base/base-field-layout.vue";
import { useInputMask } from "@Shared/@Composables/inputs/useInputMaks";
export default defineComponent({
  name: "NumberField",
  components: {
    BaseLabel,
    BaseInput,
    BaseFieldLayout
  },
  props: {
    value: {
      type: null,
      default: 0
    },
    id: {
      type: String,
      default: () => uniqueId()
    },
    name: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    validator: {
      type: Object,
      default: null
    },
    digits: {
      type: Number,
      default: 0
    },
    digitsOptional: {
      type: Boolean,
      default: true
    },
    min: {
      type: Number,
      default: _Number$MIN_SAFE_INTEGER
    },
    max: {
      type: Number,
      default: _Number$MAX_SAFE_INTEGER
    },
    sideGrid: {
      type: Boolean,
      default: false
    },
    maskType: {
      type: String,
      default: "number",
      validator: value => {
        var _context;
        return _includesInstanceProperty(_context = ["number", "decimal", "percentage", "integer"]).call(_context, value);
      }
    },
    showRequiredIndicator: {
      type: Boolean,
      default: false
    },
    hiddenLabel: {
      type: Boolean,
      defautl: false
    }
  },
  setup(props) {
    const {
      digits,
      digitsOptional,
      min,
      max,
      value,
      maskType
    } = toRefs(props);
    const {
      hasFocus,
      handleBaseFocus,
      handleBaseBlur,
      handleBaseChange,
      handleBaseInput,
      valueModel
    } = useCoreInput({
      value
    });
    const {
      buildMaskFromStringType
    } = useInputMask();
    const {
      inputMask
    } = buildMaskFromStringType({
      type: maskType.value,
      options: {
        digits,
        digitsOptional,
        min,
        max
      }
    });
    return {
      valueModel,
      hasFocus,
      handleBaseFocus,
      handleBaseBlur,
      handleBaseChange,
      handleBaseInput,
      inputMask
    };
  }
});